import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    CreateGoodsMvtRequest,
    CreateGoodsMvtResponse,
    GoodsMvtReturnMessage,
} from '../models/create-goods-request.model';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class GoodsMovementService {

    constructor(private readonly http: HttpClient,
                private readonly authService: AuthService) {
    }

    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }

    createGoodsMovement(
        requestPayload: CreateGoodsMvtRequest
    ): Observable<CreateGoodsMvtResponse> {
        const url = '/goods/create-movement';
        return this.http.post<CreateGoodsMvtResponse>(url, requestPayload, {headers: this.getHeaders()});
    }

    createGoodsInbound(
        requestPayload: CreateGoodsMvtRequest
    ): Observable<GoodsMvtReturnMessage> {
        const url = '/goods/create-inbound';
        return this.http.post<GoodsMvtReturnMessage>(url, requestPayload, {headers: this.getHeaders()});
    }
}
